import { z } from "zod";

export const createEditAreaScheme = z
  .object({
    name: z
      .string()
      .trim()
      .min(1, "Pole obligatoryjne")
      .max(255, "Nazwa jest za długa. Maksymalnie 255 znaków"),
    description: z
      .string()
      .trim()
      .max(1000, "Opis jest za długi. Maksymalnie 1000 znaków"),

    managerAsMember: z.boolean(),
  })
  .passthrough();
